import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import AppContext from "../../../context/store";
import AuthContainer from "../../../components/AuthContainer";
import styled from "styled-components";

import Button from "../../../theme/Button";

import { Grid, Column } from "../../../theme/Grid";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import "../../../assets/style/views/Employees.scss";
import Axios from "axios";
import { toast } from "react-toastify";
import { Tooltip, Switch, FormControlLabel, TextField, Chip, ButtonBase } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { FiEdit3, FiTrash2 } from "react-icons/fi";

import AlertDialog from "../../../theme/CustomMUI/AlertDialog";
import Input from "../../../theme/CustomMUI/Input";
import BetweenTimeGenerator from "../../../functions/BetweenTimeGenerator";
import FCLabel from "../../../theme/FCLabel";

const RoomsIndex = () => {
  const theme = createTheme({
    overrides: {
      MuiTooltip: {
        tooltip: {
          color: "#3189ec",
          fontSize: "12px",
          backgroundColor: "white",
          boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
        },
      },
    },
  });

  const context = useContext(AppContext);
  const history = useHistory();

  const [rooms, setRooms] = useState([...Array(6).keys()]);
  const [loaded, setLoaded] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    total_page: 1,
  });

  const [openRoomDialog, setOpenRoomDialog] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null)
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState(null);
  const [newRoom, setNewRoom] = useState({
    name: "",
    show_at_url: true,
    packages: [],
    services: [],
    closed_appointments: {
      1: { active: true, hours: [] },
      2: { active: true, hours: [] },
      3: { active: true, hours: [] },
      4: { active: true, hours: [] },
      5: { active: true, hours: [] },
      6: { active: true, hours: [] },
      7: { active: true, hours: [] },
    },
  });

  const [selectedDay, setSelectedDay] = useState(1);
  const [week, setWeek] = useState([
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
    "Pazar",
  ]);
  const [generatedHours, setGeneratedHours] = useState([]);

  // Service and package selection for async search
  const [servicesOptions, setServicesOptions] = useState([]);
  const [packagesOptions, setPackagesOptions] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [servicesSearchTimeout, setServicesSearchTimeout] = useState(null);
  const [packagesSearchTimeout, setPackagesSearchTimeout] = useState(null);

  // Cache için tüm servisleri ve paketleri tutacak state'ler
  const [allServices, setAllServices] = useState([]);
  const [allPackages, setAllPackages] = useState([]);
  const [servicesLoaded, setServicesLoaded] = useState(false);
  const [packagesLoaded, setPackagesLoaded] = useState(false);

  // Tüm servisleri bir kez getirip cache'e kaydet
  const loadAllServices = async () => {
    if (servicesLoaded) return allServices;

    try {
      const { data } = await Axios.get(`${context.api_endpoint}/company/services/filter?key=&paginate=1`);
      const services = data.data || [];
      setAllServices(services);
      setServicesLoaded(true);
      return services;
    } catch (error) {
      console.error("All services fetch error:", error);
      setAllServices([]);
      setServicesLoaded(true);
      return [];
    }
  };

  // Tüm paketleri bir kez getirip cache'e kaydet
  const loadAllPackages = async () => {
    if (packagesLoaded) return allPackages;

    try {
      const { data } = await Axios.get(`${context.api_endpoint}/company/packets?name=&page=-1`);
      const packages = data.data?.packets?.records || [];
      setAllPackages(packages);
      setPackagesLoaded(true);
      return packages;
    } catch (error) {
      console.error("All packages fetch error:", error);
      setAllPackages([]);
      setPackagesLoaded(true);
      return [];
    }
  };

  const getRooms = async () => {
    try {
      const { data } = await Axios.get(
        `${context.api_endpoint}/company/room`, {
        params: {
          page: pagination.page,
          limit: 10,
        },
      }
      );
      setLoaded(true);
      setRooms([...data.records]);
      setPagination({
        ...pagination,
        total_page: data.total_pages || Math.ceil(data.total / 10),
        page: data.current_page || data.page,
      });
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(e.response.data.message);
      } else {
        toast.warning(e.response?.data?.message || "Bir hata oluştu");
      }
    }
  };

  // Async service search function with debounce
  const searchServices = (searchText) => {
    if (servicesSearchTimeout) {
      clearTimeout(servicesSearchTimeout);
    }

    setServicesLoading(true);
    const timeout = setTimeout(async () => {
      try {
        if (!searchText || searchText.trim() === "") {
          // Arama yoksa cache'den tüm servisleri göster
          const services = await loadAllServices();
          setServicesOptions(services);
        } else {
          // Arama varsa API'ye istek at
          const { data } = await Axios.get(`${context.api_endpoint}/company/services/filter`, {
            params: {
              key: searchText,
              paginate: 1,
            },
          });
          setServicesOptions(data.data || []);
        }
      } catch (error) {
        console.error("Services search error:", error);
        setServicesOptions([]);
      } finally {
        setServicesLoading(false);
      }
    }, 500);

    setServicesSearchTimeout(timeout);
  };

  // Async package search function with debounce
  const searchPackages = (searchText) => {
    if (packagesSearchTimeout) {
      clearTimeout(packagesSearchTimeout);
    }

    setPackagesLoading(true);
    const timeout = setTimeout(async () => {
      try {
        if (!searchText || searchText.trim() === "") {
          // Arama yoksa cache'den tüm paketleri göster
          const packages = await loadAllPackages();
          setPackagesOptions(packages);
        } else {
          // Arama varsa API'ye istek at
          const { data } = await Axios.get(`${context.api_endpoint}/company/packets`, {
            params: {
              name: searchText,
              page: 1,
            },
          });
          setPackagesOptions(data.data?.packets?.records || []);
        }
      } catch (error) {
        console.error("Packages search error:", error);
        setPackagesOptions([]);
      } finally {
        setPackagesLoading(false);
      }
    }, 500);

    setPackagesSearchTimeout(timeout);
  };

  // ID'ye göre servis getir (cache'den)
  const searchServiceById = async (serviceId) => {
    try {
      // Cache'den servisleri al (yoksa yükle)
      const services = await loadAllServices();

      // Servis listesinde ara
      const service = services.find(s => s.id === serviceId);
      if (service) {
        return service;
      } else {
        return { id: serviceId, name: `Servis ${serviceId}` };
      }
    } catch (error) {
      console.error("Service by ID search error:", error);
      return { id: serviceId, name: `Servis ${serviceId}` };
    }
  };

  // ID'ye göre paket getir (cache'den)
  const searchPackageById = async (packageId) => {
    try {
      // Cache'den paketleri al (yoksa yükle)
      const packages = await loadAllPackages();

      // Paket listesinde ara
      const package_ = packages.find(p => p.id === packageId);
      if (package_) {
        return package_;
      } else {
        return { id: packageId, name: `Paket ${packageId}` };
      }
    } catch (error) {
      console.error("Package by ID search error:", error);
      return { id: packageId, name: `Paket ${packageId}` };
    }
  };

  const getRoomDetails = async (roomId) => {
    try {
      const { data } = await Axios.get(`${context.api_endpoint}/company/room/${roomId}`);
      return data;
    } catch (error) {
      console.error("Room details fetch error:", error);
      toast.error("Oda detayları alınamadı");
      return null;
    }
  };

  const createRoom = async () => {
    try {
      console.log("Selected services:", selectedServices);
      console.log("Selected packages:", selectedPackages);

      const serviceIds = selectedServices.filter(s => s && s.id).map(service => service.id);
      const packageIds = selectedPackages.filter(p => p && p.id).map(pkg => pkg.id);

      const roomData = {
        name: newRoom.name,
        show_at_url: newRoom.show_at_url,
        services: serviceIds,
        packages: packageIds,
        unavailability_json: JSON.stringify(newRoom.closed_appointments),
      };

      console.log("Room data being sent:", roomData);
      console.log("Closed appointments:", newRoom.closed_appointments);

      await Axios.post(`${context.api_endpoint}/company/room`, roomData);
      toast.success(context.t(`rooms.createSuccessToast`));
      setOpenRoomDialog(false);
      resetRoomForm();
      getRooms();
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(e.response.data.message);
      } else {
        toast.warning(e.response?.data?.message || context.t(`rooms.createErrorToast`));
      }
    }
  };

  const updateRoom = async () => {
    try {
      const serviceIds = selectedServices.filter(s => s && s.id).map(service => service.id);
      const packageIds = selectedPackages.filter(p => p && p.id).map(pkg => pkg.id);

      const roomData = {
        name: newRoom.name,
        show_at_url: newRoom.show_at_url,
        services: serviceIds,
        packages: packageIds,
        unavailability_json: JSON.stringify(newRoom.closed_appointments),
      };

      console.log("Room update data being sent:", roomData);
      console.log("Closed appointments:", newRoom.closed_appointments);

      await Axios.put(`${context.api_endpoint}/company/room/${editingRoom.ID}`, roomData);
      toast.success(context.t(`rooms.updateSuccessToast`));
      setOpenRoomDialog(false);
      resetRoomForm();
      getRooms();
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(e.response.data.message);
      } else {
        toast.warning(e.response?.data?.message || context.t(`rooms.updateErrorToast`));
      }
    }
  };

  const deleteRoom = async () => {
    try {
      await Axios.delete(`${context.api_endpoint}/company/room/${roomToDelete.ID}`);
      toast.success(context.t(`rooms.deleteSuccessToast`));
      setOpenDeleteDialog(false);
      setRoomToDelete(null);
      getRooms();
    } catch (e) {
      if (e.response?.status === 401) {
        toast.error(e.response.data.message);
      } else {
        toast.warning(e.response?.data?.message || context.t(`rooms.deleteErrorToast`));
      }
    }
  };

  const resetRoomForm = () => {
    setNewRoom({
      name: "",
      show_at_url: true,
      packages: [],
      services: [],
      closed_appointments: {
        1: { active: true, hours: [] },
        2: { active: true, hours: [] },
        3: { active: true, hours: [] },
        4: { active: true, hours: [] },
        5: { active: true, hours: [] },
        6: { active: true, hours: [] },
        7: { active: true, hours: [] },
      },
    });
    setSelectedServices([]);
    setSelectedPackages([]);
    setServicesOptions(allServices);
    setPackagesOptions(allPackages);
    setEditingRoom(null);
    setSelectedDay(1);

    // Clear timeouts
    if (servicesSearchTimeout) {
      clearTimeout(servicesSearchTimeout);
      setServicesSearchTimeout(null);
    }
    if (packagesSearchTimeout) {
      clearTimeout(packagesSearchTimeout);
      setPackagesSearchTimeout(null);
    }
  };

  // Hour status change function
  const changeHourStatus = (hour) => {
    if (!newRoom?.closed_appointments?.[selectedDay]) return;

    !newRoom.closed_appointments[selectedDay]?.hours?.includes(hour)
      ? setNewRoom({
        ...newRoom,
        closed_appointments: {
          ...newRoom.closed_appointments,
          [selectedDay]: {
            ...newRoom.closed_appointments[selectedDay],
            hours: [...(newRoom.closed_appointments[selectedDay].hours || []), hour],
          },
        },
      })
      : setNewRoom({
        ...newRoom,
        closed_appointments: {
          ...newRoom.closed_appointments,
          [selectedDay]: {
            ...newRoom.closed_appointments[selectedDay],
            hours: [
              ...(newRoom.closed_appointments[selectedDay].hours || []).filter(
                (h) => h !== hour
              ),
            ],
          },
        },
      });
  };

  // Day status change function
  const changeDayStatus = () => {
    if (!newRoom?.closed_appointments?.[selectedDay]) return;

    setNewRoom({
      ...newRoom,
      closed_appointments: {
        ...newRoom.closed_appointments,
        [selectedDay]: {
          ...newRoom.closed_appointments[selectedDay],
          active: !newRoom.closed_appointments[selectedDay].active,
        },
      },
    });
  };

  const getInitials = (name) => {
    if (!name) return "??";
    const words = name.split(" ");
    if (words.length >= 2) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  useEffect(() => {
    getRooms();
  }, [pagination.page]);

  // İlk yüklemede cache'leri doldur
  useEffect(() => {
    loadAllServices();
    loadAllPackages();
  }, []);

  // Load company shift hours
  useEffect(() => {
    Axios.get(`${context.api_endpoint}/company/itself`)
      .then(({ data }) => {
        setGeneratedHours([
          ...BetweenTimeGenerator({
            ...data.data.hours,
          }),
        ]);
      })
      .catch((e) => {
        console.error("Error loading company hours:", e);
      });
  }, []);

  return (
    <AuthContainer authorities={[1]} limited_permission="system">
      <Grid>
        <Column className="xs-12 sm-12 md-12 lg-12 xl-12" style={{ marginBottom: "50px" }}>
          <div style={{ display: "flex", position: "relative", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "20px", fontWeight: "bold", position: "absolute", left: "20px" }}>
              {context.t(`rooms.roomPageTitle`)}
            </span>
            <div style={{ display: "flex", gap: "10px", position: "absolute", right: "20px" }}>
              <MuiThemeProvider theme={theme}>
                <Tooltip title={<div>{context.t(`rooms.createRoomTitle`)}</div>} placement="top">
                  <div>
                    <Button
                      title={context.t(`rooms.createRoomTitle`)}
                      textColor="white"
                      icon="add"
                      backgroundColor="primary"
                      disabled={
                        context.state.user.permission === 2 &&
                        context.state.limited_permission.system === 1
                      }
                      onClick={() => {
                        setOpenRoomDialog(true);
                      }}
                    />
                  </div>
                </Tooltip>
              </MuiThemeProvider>
            </div>
          </div>
        </Column>
        <Column style={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <GridContainer>
            {rooms.map((room, index) =>
              loaded && room.name ? (
                <RoomCard
                  key={room.ID}
                  onClick={async () => {
                    setSelectedServices([]);
                    setSelectedPackages([]);

                    // Cache'den tüm seçenekleri yükle
                    const [services, packages] = await Promise.all([
                      loadAllServices(),
                      loadAllPackages()
                    ]);
                    setServicesOptions(services);
                    setPackagesOptions(packages);

                    const roomDetails = await getRoomDetails(room.ID);
                    if (roomDetails) {
                      setEditingRoom(room); let closedAppointments = {
                        1: { active: true, hours: [] },
                        2: { active: true, hours: [] },
                        3: { active: true, hours: [] },
                        4: { active: true, hours: [] },
                        5: { active: true, hours: [] },
                        6: { active: true, hours: [] },
                        7: { active: true, hours: [] },
                      };

                      if (roomDetails.regular_unavailability?.un_appointments) {
                        try {
                          const parsedAppointments = JSON.parse(roomDetails.regular_unavailability.un_appointments);
                          closedAppointments = parsedAppointments;
                        } catch (error) {
                          console.error("Error parsing un_appointments:", error);
                        }
                      }

                      setNewRoom({
                        name: roomDetails.name || room.name,
                        show_at_url: roomDetails.show_at_url !== undefined ? roomDetails.show_at_url : room.show_at_url,
                        packages: roomDetails.packages || [],
                        services: roomDetails.services || [],
                        closed_appointments: closedAppointments,
                      });

                      const roomServices = roomDetails.services || [];
                      const roomPackages = roomDetails.packages || [];

                      const serviceIds = roomServices.map(service => service.service.id);
                      const packageIds = roomPackages.map(pkg => pkg.packet.id);


                      const [servicesDetails, packagesDetails] = await Promise.all([
                        serviceIds.length > 0 ? Promise.all(
                          serviceIds.map(async (serviceId) => {
                            try {
                              const response = await searchServiceById(serviceId);
                              return response;
                            } catch (error) {
                              console.error(`Error fetching service ${serviceId}:`, error);
                              return { id: serviceId, name: `Servis ${serviceId}` };
                            }
                          })
                        ) : Promise.resolve([]),

                        packageIds.length > 0 ? Promise.all(
                          packageIds.map(async (packageId) => {
                            try {
                              const response = await searchPackageById(packageId);
                              return response;
                            } catch (error) {
                              console.error(`Error fetching package ${packageId}:`, error);
                              return { id: packageId, name: `Paket ${packageId}` };
                            }
                          })
                        ) : Promise.resolve([])
                      ]);

                      setSelectedServices(servicesDetails);
                      setSelectedPackages(packagesDetails);
                    }
                    setOpenRoomDialog(true);
                  }}
                >
                  <DeleteButton onClick={(e) => {
                    e.stopPropagation();
                    setRoomToDelete(room);
                    setOpenDeleteDialog(true);
                  }}>
                    <FiTrash2
                      size={16}
                      color="#db2828"
                    />
                  </DeleteButton>
                  <EditButton>
                    <FiEdit3
                      size={16}
                      color="#3189ec"
                      onClick={async (e) => {
                        e.stopPropagation();

                        setSelectedServices([]);
                        setSelectedPackages([]);

                        // Cache'den tüm seçenekleri yükle
                        const [services, packages] = await Promise.all([
                          loadAllServices(),
                          loadAllPackages()
                        ]);
                        setServicesOptions(services);
                        setPackagesOptions(packages);

                        const roomDetails = await getRoomDetails(room.ID);
                        if (roomDetails) {
                          setEditingRoom(room);

                          let closedAppointments = {
                            1: { active: true, hours: [] },
                            2: { active: true, hours: [] },
                            3: { active: true, hours: [] },
                            4: { active: true, hours: [] },
                            5: { active: true, hours: [] },
                            6: { active: true, hours: [] },
                            7: { active: true, hours: [] },
                          };

                          if (roomDetails.regular_unavailability?.un_appointments) {
                            try {
                              const parsedAppointments = JSON.parse(roomDetails.regular_unavailability.un_appointments);
                              closedAppointments = parsedAppointments;
                            } catch (error) {
                              console.error("Error parsing un_appointments:", error);
                            }
                          }

                          setNewRoom({
                            name: roomDetails.name || room.name,
                            show_at_url: roomDetails.show_at_url !== undefined ? roomDetails.show_at_url : room.show_at_url,
                            packages: roomDetails.packages || [],
                            services: roomDetails.services || [],
                            closed_appointments: closedAppointments,
                          });

                          const roomServices = roomDetails.services || [];
                          const roomPackages = roomDetails.packages || [];

                          const serviceIds = roomServices.map(service => service.service.id);
                          const packageIds = roomPackages.map(pkg => pkg.packet.id);

                          const [servicesDetails, packagesDetails] = await Promise.all([
                            serviceIds.length > 0 ? Promise.all(
                              serviceIds.map(async (serviceId) => {
                                try {
                                  const response = await searchServiceById(serviceId);
                                  return response;
                                } catch (error) {
                                  console.error(`Error fetching service ${serviceId}:`, error);
                                  return { id: serviceId, name: `Servis ${serviceId}` };
                                }
                              })
                            ) : Promise.resolve([]),

                            packageIds.length > 0 ? Promise.all(
                              packageIds.map(async (packageId) => {
                                try {
                                  const response = await searchPackageById(packageId);
                                  return response;
                                } catch (error) {
                                  console.error(`Error fetching package ${packageId}:`, error);
                                  return { id: packageId, name: `Paket ${packageId}` };
                                }
                              })
                            ) : Promise.resolve([])
                          ]);

                          setSelectedServices(servicesDetails);
                          setSelectedPackages(packagesDetails);
                        }
                        setOpenRoomDialog(true);
                      }}
                    />
                  </EditButton>
                  <InitialsCircle>
                    <InitialsText>{getInitials(room.name)}</InitialsText>
                  </InitialsCircle>
                  <RoomName>{room.name}</RoomName>
                  <RoomStatus>
                    {room.show_at_url ? context.t(`rooms.urlShowingStatus`) : context.t(`rooms.urlHiddenStatus`)}
                  </RoomStatus>
                </RoomCard>
              ) : (
                <RoomCard key={index}>
                  <SkeletonInitialsCircle className="skeleton" />
                  <SkeletonRoomName className="skeleton" />
                  <SkeletonRoomStatus className="skeleton" />
                  <SkeletonActionButton className="skeleton" />
                </RoomCard>
              )
            )}
          </GridContainer>
        </Column>
      </Grid>
      <Grid>
        <PaginationContainer>
          <div className="pagination p7">
            <ul>
              <button
                disabled={pagination.page <= 1}
                onClick={() => {
                  setPagination({
                    ...pagination,
                    page: pagination.page - 1,
                  });
                }}
              >
                <li>
                  <ArrowBackIosIcon className="icon-back" fontSize="small" />
                </li>
              </button>
              <button
                disabled={pagination.page >= pagination.total_page}
                onClick={() => {
                  setPagination({
                    ...pagination,
                    page: pagination.page + 1,
                  });
                }}
              >
                <li>
                  <ArrowForwardIosIcon fontSize="small" />
                </li>
              </button>
            </ul>
          </div>
        </PaginationContainer>
      </Grid>

      {/* Room Creation/Edit Dialog */}
      <AlertDialog
        open={openRoomDialog}
        title={editingRoom ? context.t(`rooms.editRoomTitle`) : context.t(`rooms.createRoomTitle`)}
        maxWidth="md"
        fullWidth
        closeHandler={() => {
          setOpenRoomDialog(false);
          resetRoomForm();
        }}
        buttons={[
          {
            title: editingRoom ? context.t(`rooms.updateButton`) : context.t(`rooms.createButton`),
            icon: "check",
            backgroundColor: "primary",
            textColor: "white",
            onClick: editingRoom ? updateRoom : createRoom,
            disabled: !newRoom.name.trim(),
          },
          {
            title: context.t(`rooms.cancelButton`),
            icon: "close",
            backgroundColor: "grey-opacity",
            textColor: "grey",
          },
        ]}
      >
        <Grid className="no-gutters-row">
          <Column className="xs-12 sm-12 md-12 lg-12">
            <Input
              required
              label={context.t(`rooms.roomNameLabel`)}
              value={newRoom.name}
              onChange={(e) =>
                setNewRoom({ ...newRoom, name: e.target.value })
              }
              placeholder={context.t(`rooms.roomNamePlaceholder`)}
            />
          </Column>
        </Grid>

        <Grid className="no-gutters-row">
          <Column className="xs-12 sm-12 md-12 lg-12">
            <FormControlLabel
              control={
                <Switch
                  checked={newRoom.show_at_url}
                  onChange={(e) =>
                    setNewRoom({ ...newRoom, show_at_url: e.target.checked })
                  }
                  color="primary"
                />
              }
              label={context.t(`rooms.showAtUrlLabel`)}
            />
          </Column>
        </Grid>

        <Grid className="no-gutters-row">
          <Column className="xs-12 sm-12 md-6 lg-6" style={{ marginBottom: "16px" }}>
            <Autocomplete
              multiple
              id="services-autocomplete"
              options={servicesOptions}
              getOptionLabel={(option) => option.name}
              value={selectedServices}
              onChange={(event, newValue) => {
                setSelectedServices(newValue);
              }}
              onInputChange={(event, newInputValue) => {
                searchServices(newInputValue);
              }}
              onOpen={() => {
                if (servicesOptions.length === 0) {
                  searchServices("");
                }
              }}
              onFocus={() => {
                if (servicesOptions.length === 0) {
                  searchServices("");
                }
              }}
              filterSelectedOptions
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="default"
                    label={option.name}
                    {...getTagProps({ index })}
                    key={option.id}
                    size="small"
                    style={{
                      margin: "2px 4px 2px 0",
                      height: "28px",
                      fontSize: "13px",
                      backgroundColor: "#e3f2fd",
                      color: "#1976d2",
                      border: "1px solid #bbdefb",
                      borderRadius: "16px"
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={context.t(`rooms.servicesLabel`)}
                  placeholder={selectedServices.length === 0 ? context.t(`rooms.servicesPlaceholder`) : ""}
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {servicesLoading ? (
                          <div style={{ fontSize: "12px", color: "#999", marginRight: "8px" }}>
                            Aranıyor...
                          </div>
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              size="medium"
              style={{ marginBottom: "16px" }}
              loading={servicesLoading}
              loadingText="Hizmetler aranıyor..."
              noOptionsText="Hizmet bulunamadı"
            />
          </Column>

          <Column className="xs-12 sm-12 md-6 lg-6" style={{ marginBottom: "16px" }}>
            <Autocomplete
              multiple
              id="packages-autocomplete"
              options={packagesOptions}
              getOptionLabel={(option) => option.name}
              value={selectedPackages}
              onChange={(event, newValue) => {
                setSelectedPackages(newValue);
              }}
              onInputChange={(event, newInputValue) => {
                searchPackages(newInputValue);
              }}
              onOpen={() => {
                if (packagesOptions.length === 0) {
                  searchPackages("");
                }
              }}
              onFocus={() => {
                if (packagesOptions.length === 0) {
                  searchPackages("");
                }
              }}
              filterSelectedOptions
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="default"
                    label={option.name}
                    {...getTagProps({ index })}
                    key={option.id}
                    size="small"
                    style={{
                      margin: "2px 4px 2px 0",
                      height: "28px",
                      fontSize: "13px",
                      backgroundColor: "#fff3e0",
                      color: "#f57c00",
                      border: "1px solid #ffcc02",
                      borderRadius: "16px"
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label={context.t(`rooms.packagesLabel`)}
                  placeholder={selectedPackages.length === 0 ? context.t(`rooms.packagesPlaceholder`) : ""}
                  fullWidth
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {packagesLoading ? (
                          <div style={{ fontSize: "12px", color: "#999", marginRight: "8px" }}>
                            Aranıyor...
                          </div>
                        ) : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              size="medium"
              style={{ marginBottom: "16px" }}
              loading={packagesLoading}
              loadingText="Paketler aranıyor..."
              noOptionsText="Paket bulunamadı"
            />
          </Column>
        </Grid>

        {/* Randevu Saatleri Bölümü */}
        <Grid className="no-gutters-row" style={{ marginTop: "20px" }}>
          <Column className="xs-12 sm-12 md-12 lg-12">
            <h3 style={{ marginBottom: "16px", fontSize: "18px", fontWeight: "bold" }}>
              {context.t(`profile.booking.title`)}
            </h3>

            <DayTabContainer>
              {week.map((item, index) => (
                <ButtonBase key={index}>
                  <StyledDayTab
                    key={index}
                    className="ripple"
                    day={index + 1}
                    selected_day={selectedDay}
                    onClick={() => {
                      setSelectedDay(index + 1);
                    }}
                    children={item}
                  />
                </ButtonBase>
              ))}
            </DayTabContainer>

            <FormControlLabel
              className="mb-2"
              control={
                <Switch
                  color="primary"
                  checked={newRoom?.closed_appointments[selectedDay]?.active}
                  onChange={() => changeDayStatus(selectedDay)}
                />
              }
              label={
                <FCLabel>
                  {newRoom?.closed_appointments[selectedDay]?.active === true
                    ? context.t(`profile.booking.dayCloseText`)
                    : context.t(`profile.booking.dayOpenText`)}
                </FCLabel>
              }
            />

            <div style={{ marginTop: "16px", display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {parseInt(context.state.company_shift?.slice || 0) > 0 && generatedHours.map((hour, index) => (
                <div key={index} style={{ flex: "0 0 calc(16.66% - 8px)", minWidth: "120px" }}>
                  <Button
                    disabled={!newRoom?.closed_appointments?.[selectedDay]?.active}
                    key={index}
                    fullWidth={true}
                    className={
                      newRoom?.closed_appointments?.[selectedDay]?.active &&
                        !newRoom?.closed_appointments?.[selectedDay]?.hours?.includes(hour)
                        ? `elevation-2`
                        : ""
                    }
                    onClick={() => changeHourStatus(hour)}
                    icon={
                      newRoom?.closed_appointments?.[selectedDay]?.active &&
                        !newRoom?.closed_appointments?.[selectedDay]?.hours?.includes(hour)
                        ? "check"
                        : "close"
                    }
                    title={hour}
                    backgroundColor={"white"}
                    textColor={
                      newRoom?.closed_appointments?.[selectedDay]?.active &&
                        !newRoom?.closed_appointments?.[selectedDay]?.hours?.includes(hour)
                        ? "#21ba45"
                        : "#db2828"
                    }
                    style={{
                      border: newRoom?.closed_appointments?.[selectedDay]?.active &&
                        !newRoom?.closed_appointments?.[selectedDay]?.hours?.includes(hour)
                        ? "1px solid #21ba45"
                        : "1px solid #db2828",
                      height: "42px",
                      fontSize: "12px"
                    }}
                  />
                </div>
              ))}
            </div>
          </Column>
        </Grid>
      </AlertDialog>

      {/* Delete Confirmation Dialog */}
      <AlertDialog
        open={openDeleteDialog}
        title={context.t(`menuItems.rooms.deleteRoomTitle`)}
        maxWidth="sm"
        fullWidth
        closeHandler={() => {
          setOpenDeleteDialog(false);
          setRoomToDelete(null);
        }}
        buttons={[
          {
            title: context.t(`menuItems.rooms.deleteButton`),
            icon: "delete",
            backgroundColor: "red",
            textColor: "white",
            onClick: deleteRoom,
          },
          {
            title: context.t(`menuItems.rooms.cancelButton`),
            icon: "close",
            backgroundColor: "grey-opacity",
            textColor: "grey",
            onClick: () => {
              setOpenDeleteDialog(false);
              setRoomToDelete(null);
            },
          },
        ]}
      >
        <div style={{ padding: "20px 0" }}>
          <p style={{ fontSize: "16px", textAlign: "center", margin: 0 }}>
            <strong>"{roomToDelete?.name}"</strong> {context.t(`menuItems.rooms.deleteConfirmationText`)}
          </p>
        </div>
      </AlertDialog>
    </AuthContainer>
  );
};

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 2fr);
  gap: 20px;
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 16px;
  }
  
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }
`;

const RoomCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 37px;
  padding-bottom: 10px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  &:hover {
    background: #fafafa;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: #3189ec;
  }

  &:active {
    transform: translateY(0);
  }
`;

const InitialsCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
`;

const InitialsText = styled.span`
  color: white;
  font-size: 28px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
`;

const RoomName = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2d3748;
  font-family: 'Inter', sans-serif;
  line-height: 1.3;
`;

const RoomStatus = styled.span`
  display: block;
  font-size: 13px;
  color: #718096;
  font-weight: 500;
  padding: 4px 12px;
  background: #f7fafc;
  border-radius: 20px;
  display: inline-block;
  margin-top: 4px;
`;

const EditButton = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(49, 137, 239, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(49, 137, 239, 0.2);

  &:hover {
    background: rgba(49, 137, 239, 0.15);
    border-color: rgba(49, 137, 239, 0.3);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const DeleteButton = styled.div`
  position: absolute;
  top: 12px;
  right: 56px;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(219, 40, 40, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid rgba(219, 40, 40, 0.2);

  &:hover {
    background: rgba(219, 40, 40, 0.15);
    border-color: rgba(219, 40, 40, 0.3);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const SkeletonInitialsCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 16px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const SkeletonRoomName = styled.div`
  width: 120px;
  height: 18px;
  margin: 0 auto 8px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const SkeletonRoomStatus = styled.div`
  width: 100px;
  height: 24px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin: 4px auto 0;
  border-radius: 20px;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const SkeletonActionButton = styled.div`
  width: 36px;
  height: 36px;
  position: absolute;
  top: 12px;
  right: 12px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  box-sizing: border-box;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const StyledDayTab = styled.div`
  width: auto;
  flex: none;
  text-align: center;
  font-size: 14px;
  padding: 16px;
  font-weight: 500;
  color: ${({ day, selected_day }) =>
    day === selected_day ? "var(--primary)" : "var(--black)"};
  border-bottom: 2px solid
    ${({ day, selected_day }) =>
    day === selected_day ? "var(--primary)" : "var(--white)"};
  box-sizing: border-box;
  cursor: pointer;
`;

const DayTabContainer = styled.div`
  width: -webkit-fill-available;
  position: relative;
  z-index: 100;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden !important;
  list-style: none;
  display: inline-flex;
  margin-bottom: 16px;
  box-sizing: content-box;

  button {
    font-family: "Inter", sans-serif !important;
  }
`;

export default RoomsIndex;
